module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/bus.svg?a84d08089d685f57cdf65014324977a6";